import styled from 'styled-components';
import { NotifyIcon } from 'web-components';

export const InfoIcon = styled(NotifyIcon)`
  color: #58baaa !important;
  font-size: 1.1rem !important;
`;
